import React from 'react';
import Select from "react-select";
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

const MultiDdl = ({data, selectArray,defaultSelect}) => {

    function extractArray(selected) {
        let options = []
        selected.map((d) =>
            options.push(d.value)
        )
        return options
    }
    function extract(data) {
        let options = []
        data.map((d) =>
            options.push({value: d.name, label: d.name})
        )
        return options
    }

    const handleT = (selected) => {
        selectArray(extractArray(selected))
    }
    const result = extract(data)
    
    const defaultValues = defaultSelect ? result.filter(opt => defaultSelect.includes(opt.value)) : null;

    const customStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: '40px',
            borderColor: state.isFocused ? '#3b82f6' : '#E5E7EB',
            borderRadius: '0.5rem',
            borderWidth: state.isFocused ? '2px' : '1px',
            boxShadow: state.isFocused ? '0 0 0 3px rgba(59, 130, 246, 0.1)' : 'none',
            transition: 'all 0.2s ease',
            '&:hover': {
                borderColor: state.isFocused ? '#3b82f6' : '#D1D5DB',
            },
        }),
        valueContainer: (base) => ({
            ...base,
            padding: '0 12px',
            minHeight: '40px',
        }),
        input: (base) => ({
            ...base,
            margin: 0,
            padding: 0,
            fontSize: '0.875rem',
            fontWeight: '400',
        }),
        placeholder: (base) => ({
            ...base,
            color: '#6B7280',
            fontSize: '0.875rem',
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: '#F99600',
            borderRadius: '0.375rem',
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: '#FFFFFF',
            fontSize: '0.875rem',
            fontWeight: '500',
        }),
        multiValueRemove: (base) => ({
            ...base,
            color: '#FFFFFF',
            borderRadius: '0 0.375rem 0.375rem 0',
            '&:hover': {
                backgroundColor: '#d77a1e',
                color: '#FFFFFF',
            },
        }),
        menu: (base) => ({
            ...base,
            borderRadius: '0.5rem',
            border: '1px solid #E5E7EB',
            boxShadow: 'none',
            marginTop: '4px',
        }),
        menuList: (base) => ({
            ...base,
            padding: '4px',
        }),
        option: (base, state) => ({
            ...base,
            fontSize: '0.875rem',
            color: state.isSelected ? '#FFFFFF' : '#111827',
            backgroundColor: state.isSelected 
                ? '#F99600' 
                : state.isFocused 
                    ? '#fff6eb' 
                    : 'white',
            borderRadius: '0.375rem',
            padding: '8px 12px',
            margin: '2px 0',
            cursor: 'pointer',
            fontWeight: state.isSelected ? '500' : '400',
            transition: 'all 0.15s ease',
            '&:active': {
                backgroundColor: '#F99600',
                color: '#FFFFFF',
            },
        }),
        indicatorSeparator: () => ({
            display: 'none',
        }),
        dropdownIndicator: (base) => ({
            ...base,
            color: '#6B7280',
            padding: '8px',
            '&:hover': {
                color: '#374151',
            },
        }),
        clearIndicator: (base) => ({
            ...base,
            color: '#6B7280',
            padding: '8px',
            '&:hover': {
                color: '#374151',
            },
        }),
    };

    return (
        <>
            <Select
                closeMenuOnSelect={false}
                components={animatedComponents}
                onChange={handleT}
                isMulti
                value={defaultValues}
                options={result}
                styles={customStyles}
                classNamePrefix="react-select"
            />
        </>
    );
};

export default MultiDdl;